import React from "react";
const Pylecture3 = () => {
  return (
    <div className="bg-gray-100 flex items-center justify-center min-h-screen">
      <div className="w-full max-w-xl p-4 bg-white rounded-lg shadow-md">
        <div className="aspect-w-16 aspect-h-9 mb-4">
          <iframe
            className="w-full rounded-lg"
            width="560"
            height="315"
            src="https://www.youtube.com/embed/VPvTLzyGi8Y?si=nT6MFJAXDqhAFKSM"
            title="Python"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen;"
            //referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <h2 className="text-2xl font-bold mb-2">
          📚 Python Programming - Lecture 3: Understanding Python Data Types:
          Examples & Best Practices 🎉
        </h2>
        <p className="text-gray-700">
          Welcome to our comprehensive lecture on Python data types! In this
          video, we'll delve into the essential building blocks of Python
          programming: data types. Whether you're a beginner or looking to
          refresh your knowledge, this lecture is designed to help you master
          the different data types in Python with real-life examples and best
          practices.
          <br />
          <br />
          🔹 Introduction to Data Types: Understand the concept of data types
          and their importance in programming.
          <br />
          <br />
          🔹 Basic Data Types: Learn about integers, floats, strings, and
          booleans.
          <br />
          <br />
          🔹 Type Conversion: Discover how to convert between different data
          types.
          <br />
          <br />
          🔹 Best Practices: Tips and tricks for using data types effectively
          and efficiently in your code.
          <br />
          <br />
          Join us to build a solid foundation in Python programming and enhance
          your coding skills. Don't forget to like, share, and subscribe for
          more tutorials!
          <br />
          <br />
          Happy coding! 💻
        </p>
      </div>
    </div>
  );
};

export default Pylecture3;
